// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.company-director-container {
  container-type: inline-size;
  position: relative;
  width: 100%;
  height: 100%;
  min-width: 328px;
  min-height: 400px;
  box-sizing: border-box;
  background-color: var(--surface-primary);
}

.company-director-skeleton-loading-container {
  width: 100%;
  padding: 16px;
  box-sizing: border-box;
}

.director-th {
  display: flex;
  gap: 2px;
  color: var(--text-subheader);
  cursor: pointer;
  user-select: none;
  position: relative;
  align-items: center;
  text-align: left;
}

.director-th--right {
  flex-direction: row;
  justify-content: flex-end;
  align-items: flex-start;
  text-align: right;
}

.director-th-text-stack {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

.director-sort-icon {
  width: 20px;
  height: 20px;
  flex-shrink: 0;
}

.director-sort-icon--fill path {
  fill: var(--color-brand);
}

.director-sort-icon--hidden {
  visibility: hidden;
}

.director-filter-icon {
  width: 12px;
  height: 12px;
  flex-shrink: 0;
  margin-left: 2px;
}

.director-filter-icon path {
  fill: var(--text-subheader);
}

.director-td {
  display: flex;
  align-items: center;
  padding: 12px 0;
  color: var(--text-primary);
  min-width: 0;
}

.director-td--right {
  justify-content: flex-end;
  text-align: right;
}

.director-td--top {
  align-items: flex-start;
  padding: 8px 0 12px 0;
  text-align: left;
}

.director-td-active {
  border-bottom: 1px dashed var(--border-primary);
}

.director-td-instrument {
  color: var(--text-instrument);
}

.director-name-group {
  display: flex;
  flex-direction: column;
  min-width: 0;
  color: var(--text-instrument);
}

.director-name-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.text-primary {
  color: var(--text-primary);
}

.director-position-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding-bottom: 2px;
}

.director-expanded-header,
.director-expanded-row {
  display: grid;
  grid-template-columns:
    minmax(0, 2fr) minmax(0, 2.5fr) minmax(0, 1fr)
    minmax(0, 1fr) minmax(0, 1.5fr);
  box-sizing: border-box;
  box-shadow: inset 0 -1px 0 0 var(--border-tertiary);
}

.director-expanded-header {
  align-items: flex-start;
  padding: 0 32px 8px 32px;
  border-bottom: none;
  position: relative;
}

.director-expanded-header::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 32px;
  right: 32px;
  height: 1px;
  background-color: var(--border-line);
}

.director-expanded-row {
  padding: 0 32px;
}

.director-expanded-row .director-td {
  padding: 8px 0;
}

.director-expanded-row:last-child {
  border-bottom: none;
}

.director-basic-header,
.director-basic-row {
  display: grid;
  grid-template-columns:
    minmax(0, 1.2fr) minmax(0, 1.5fr) minmax(0, 1fr)
    minmax(0, 1fr) minmax(0, 1.5fr);
  box-sizing: border-box;
  box-shadow: inset 0 -1px 0 0 var(--border-tertiary);
}

.director-basic-row .director-td:first-child {
  grid-column: span 2;
}

.director-basic-header {
  align-items: flex-start;
  padding: 0 16px 8px 16px;
  border-bottom: none;
  position: relative;
}

.director-basic-header::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 16px;
  right: 16px;
  height: 1px;
  background-color: var(--border-line);
}

.director-basic-row {
  padding: 0 16px;
}

.director-basic-row .director-td {
  padding: 8px 0;
}

.director-basic-row:last-child {
  border-bottom: none;
}

.director-mobile-header {
  display: flex;
  align-items: center;
  padding-bottom: 8px;
  margin: 0 16px;
  box-sizing: border-box;
  border-bottom: 1px solid var(--border-line);
  position: relative;
}

.director-mobile-row {
  display: grid;
  grid-template-columns: 1fr auto;
  padding: 0 16px;
  box-sizing: border-box;
  border-bottom: 1px solid var(--border-tertiary);
  cursor: pointer;
  outline: none;
}

.director-mobile-row:last-child {
  border-bottom: none;
}

.director-mobile-details {
  grid-column: 1 / -1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  max-height: 0;
  padding-bottom: 0;
  transition:
    max-height 0.25s ease,
    padding-bottom 0.25s ease;
}

.director-mobile-details--open {
  max-height: 300px;
  padding-bottom: 12px;
}

.director-mobile-detail-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  padding: 8px 16px 0 0;
}

.director-mobile-detail-label {
  color: var(--text-label);
}

.director-mobile-detail-value {
  color: var(--text-primary);
}

.director-chevron {
  width: 20px;
  height: 20px;
  transition: transform 0.2s ease;
  flex-shrink: 0;
}

.director-chevron path {
  fill: var(--text-primary);
}

.director-chevron--up {
  transform: rotate(180deg);
}

.director-sort-dropdown {
  position: absolute;
  top: 100%;
  left: auto;
  right: 12%;
  z-index: 10;
  background-color: var(--surface-primary);
  border: 1px solid var(--border-tertiary);
  border-radius: 4px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
  min-width: 200px;
  padding: 4px 0;
}

.director-sort-dropdown-header {
  padding: 8px 12px;
  color: var(--text-label);
  border-bottom: 1px dashed var(--border-primary);
  text-align: left;
}

.director-sort-dropdown-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 8px 12px;
  color: var(--text-primary);
  cursor: pointer;
}

.director-sort-dropdown-item:hover {
  background-color: var(--row-dark);
}

.director-sort-dropdown-item--active {
  color: var(--color-brand);
}

.director-sort-dropdown-tick {
  width: 12px;
  height: 12px;
  flex-shrink: 0;
}

.director-sort-dropdown-tick path {
  fill: var(--color-brand);
}
@container (max-width: 360px) {
  .director-sort-dropdown {
    right: 24%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Widgets/CompanyDirectorWidget/CompanyDirectorWidget.css"],"names":[],"mappings":"AAAA;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,4BAA4B;EAC5B,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,0BAA0B;EAC1B,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;;EAEE,aAAa;EACb;;mCAEiC;EACjC,sBAAsB;EACtB,mDAAmD;AACrD;;AAEA;EACE,uBAAuB;EACvB,wBAAwB;EACxB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;EACX,WAAW;EACX,oCAAoC;AACtC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,aAAa;EACb;;mCAEiC;EACjC,sBAAsB;EACtB,mDAAmD;AACrD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,wBAAwB;EACxB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;EACX,WAAW;EACX,oCAAoC;AACtC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,sBAAsB;EACtB,2CAA2C;EAC3C,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,eAAe;EACf,sBAAsB;EACtB,+CAA+C;EAC/C,eAAe;EACf,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,aAAa;EACb,iBAAiB;EACjB;;6BAE2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,UAAU;EACV,WAAW;EACX,wCAAwC;EACxC,wCAAwC;EACxC,kBAAkB;EAClB,0CAA0C;EAC1C,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;EACxB,+CAA+C;EAC/C,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,iBAAiB;EACjB,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,wBAAwB;AAC1B;AACA;EACE;IACE,UAAU;EACZ;AACF","sourcesContent":[".company-director-container {\n  container-type: inline-size;\n  position: relative;\n  width: 100%;\n  height: 100%;\n  min-width: 328px;\n  min-height: 400px;\n  box-sizing: border-box;\n  background-color: var(--surface-primary);\n}\n\n.company-director-skeleton-loading-container {\n  width: 100%;\n  padding: 16px;\n  box-sizing: border-box;\n}\n\n.director-th {\n  display: flex;\n  gap: 2px;\n  color: var(--text-subheader);\n  cursor: pointer;\n  user-select: none;\n  position: relative;\n  align-items: center;\n  text-align: left;\n}\n\n.director-th--right {\n  flex-direction: row;\n  justify-content: flex-end;\n  align-items: flex-start;\n  text-align: right;\n}\n\n.director-th-text-stack {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n}\n\n.director-sort-icon {\n  width: 20px;\n  height: 20px;\n  flex-shrink: 0;\n}\n\n.director-sort-icon--fill path {\n  fill: var(--color-brand);\n}\n\n.director-sort-icon--hidden {\n  visibility: hidden;\n}\n\n.director-filter-icon {\n  width: 12px;\n  height: 12px;\n  flex-shrink: 0;\n  margin-left: 2px;\n}\n\n.director-filter-icon path {\n  fill: var(--text-subheader);\n}\n\n.director-td {\n  display: flex;\n  align-items: center;\n  padding: 12px 0;\n  color: var(--text-primary);\n  min-width: 0;\n}\n\n.director-td--right {\n  justify-content: flex-end;\n  text-align: right;\n}\n\n.director-td--top {\n  align-items: flex-start;\n  padding: 8px 0 12px 0;\n  text-align: left;\n}\n\n.director-td-active {\n  border-bottom: 1px dashed var(--border-primary);\n}\n\n.director-td-instrument {\n  color: var(--text-instrument);\n}\n\n.director-name-group {\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n  color: var(--text-instrument);\n}\n\n.director-name-text {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.text-primary {\n  color: var(--text-primary);\n}\n\n.director-position-text {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  padding-bottom: 2px;\n}\n\n.director-expanded-header,\n.director-expanded-row {\n  display: grid;\n  grid-template-columns:\n    minmax(0, 2fr) minmax(0, 2.5fr) minmax(0, 1fr)\n    minmax(0, 1fr) minmax(0, 1.5fr);\n  box-sizing: border-box;\n  box-shadow: inset 0 -1px 0 0 var(--border-tertiary);\n}\n\n.director-expanded-header {\n  align-items: flex-start;\n  padding: 0 32px 8px 32px;\n  border-bottom: none;\n  position: relative;\n}\n\n.director-expanded-header::after {\n  content: '';\n  position: absolute;\n  bottom: 0;\n  left: 32px;\n  right: 32px;\n  height: 1px;\n  background-color: var(--border-line);\n}\n\n.director-expanded-row {\n  padding: 0 32px;\n}\n\n.director-expanded-row .director-td {\n  padding: 8px 0;\n}\n\n.director-expanded-row:last-child {\n  border-bottom: none;\n}\n\n.director-basic-header,\n.director-basic-row {\n  display: grid;\n  grid-template-columns:\n    minmax(0, 1.2fr) minmax(0, 1.5fr) minmax(0, 1fr)\n    minmax(0, 1fr) minmax(0, 1.5fr);\n  box-sizing: border-box;\n  box-shadow: inset 0 -1px 0 0 var(--border-tertiary);\n}\n\n.director-basic-row .director-td:first-child {\n  grid-column: span 2;\n}\n\n.director-basic-header {\n  align-items: flex-start;\n  padding: 0 16px 8px 16px;\n  border-bottom: none;\n  position: relative;\n}\n\n.director-basic-header::after {\n  content: '';\n  position: absolute;\n  bottom: 0;\n  left: 16px;\n  right: 16px;\n  height: 1px;\n  background-color: var(--border-line);\n}\n\n.director-basic-row {\n  padding: 0 16px;\n}\n\n.director-basic-row .director-td {\n  padding: 8px 0;\n}\n\n.director-basic-row:last-child {\n  border-bottom: none;\n}\n\n.director-mobile-header {\n  display: flex;\n  align-items: center;\n  padding-bottom: 8px;\n  margin: 0 16px;\n  box-sizing: border-box;\n  border-bottom: 1px solid var(--border-line);\n  position: relative;\n}\n\n.director-mobile-row {\n  display: grid;\n  grid-template-columns: 1fr auto;\n  padding: 0 16px;\n  box-sizing: border-box;\n  border-bottom: 1px solid var(--border-tertiary);\n  cursor: pointer;\n  outline: none;\n}\n\n.director-mobile-row:last-child {\n  border-bottom: none;\n}\n\n.director-mobile-details {\n  grid-column: 1 / -1;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  max-height: 0;\n  padding-bottom: 0;\n  transition:\n    max-height 0.25s ease,\n    padding-bottom 0.25s ease;\n}\n\n.director-mobile-details--open {\n  max-height: 300px;\n  padding-bottom: 12px;\n}\n\n.director-mobile-detail-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 16px;\n  padding: 8px 16px 0 0;\n}\n\n.director-mobile-detail-label {\n  color: var(--text-label);\n}\n\n.director-mobile-detail-value {\n  color: var(--text-primary);\n}\n\n.director-chevron {\n  width: 20px;\n  height: 20px;\n  transition: transform 0.2s ease;\n  flex-shrink: 0;\n}\n\n.director-chevron path {\n  fill: var(--text-primary);\n}\n\n.director-chevron--up {\n  transform: rotate(180deg);\n}\n\n.director-sort-dropdown {\n  position: absolute;\n  top: 100%;\n  left: auto;\n  right: 12%;\n  z-index: 10;\n  background-color: var(--surface-primary);\n  border: 1px solid var(--border-tertiary);\n  border-radius: 4px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);\n  min-width: 200px;\n  padding: 4px 0;\n}\n\n.director-sort-dropdown-header {\n  padding: 8px 12px;\n  color: var(--text-label);\n  border-bottom: 1px dashed var(--border-primary);\n  text-align: left;\n}\n\n.director-sort-dropdown-item {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  padding: 8px 12px;\n  color: var(--text-primary);\n  cursor: pointer;\n}\n\n.director-sort-dropdown-item:hover {\n  background-color: var(--row-dark);\n}\n\n.director-sort-dropdown-item--active {\n  color: var(--color-brand);\n}\n\n.director-sort-dropdown-tick {\n  width: 12px;\n  height: 12px;\n  flex-shrink: 0;\n}\n\n.director-sort-dropdown-tick path {\n  fill: var(--color-brand);\n}\n@container (max-width: 360px) {\n  .director-sort-dropdown {\n    right: 24%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
